import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { routerHistory } from 'app/core/router/service';
import rootReducer from 'app/store/rootReducer';
import rootSaga from 'app/store/rootSaga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storageService from 'app/core/services/storageService';
import environment from 'environments';
import commonService from 'app/core/services/commonService';

// Create Middleware
const reduxSagaMiddleware = createSagaMiddleware();
const reduxRouterMiddleware = routerMiddleware(routerHistory);
const appReduxMiddlewares = applyMiddleware(reduxSagaMiddleware, reduxRouterMiddleware);

// Create rootMiddleware based on environment
let rootMiddleware;
if (process.env.NODE_ENV !== 'production') {
  // non-prod env
  const { composeWithDevTools } = require('redux-devtools-extension');
  rootMiddleware = composeWithDevTools(appReduxMiddlewares);
} else {
  // prod env
  rootMiddleware = appReduxMiddlewares;
}

// redux-persist Config
const persistConfig = {
  key: 'root',
  storage: storage,
  transforms: [
    encryptTransform({
      secretKey: commonService.decryptAES(environment.frontend.persist),
      onError: function (error) {
        console.error('encryption error', error);
        // 清除所有資料並重載
        storageService.clearAll.all();
        window.location.reload();
      }
    })
  ],
  blacklist: ['UI'] // UI 為即時狀態，不適用於批次
};

// 建立持久化的 reducer
const persistReducerInstance = persistReducer(persistConfig, rootReducer);

// Create store
const store = createStore(persistReducerInstance, rootMiddleware);

// Run saga
reduxSagaMiddleware.run(rootSaga);

// 回傳持久化的 store (Provider)
export const persistor = persistStore(store);
export default store;
